import { gql } from '@apollo/client'
import { sortReplies } from '@btime/helpers'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { usePermalinkToken } from '../../../../utils/session/permalinkToken'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useServiceOrderState = () => React.useContext(Context)
export const useServiceOrder = () => useServiceOrderState()?.serviceOrder
export const useReplies = () => {
  const replies = useServiceOrder()?.replies || []
  return sortReplies(replies)
}

const QUERY = gql`
  query ServiceOrder($id: ID, $permalinkToken: String) {
    serviceOrder(id: $id, permalinkToken: $permalinkToken, filter: { includeDeleted: true, ignoreSegments: true }) {
      id
      name
      yearlyId
      startDate
      endDate
      deleted
      insertedAt
      updatedAt
      slaExpiresAt
      executionToken
      address {
        search
        complement
      }
      fieldValues {
        id
        value
        fieldId
        field {
          type
          id
          name
          configuration
          options {
            id
            name
            reference
            ordination
          }
        }
      }
      scheduling
      customerCode
      internalCode
      invoice
      description
      documents {
        id
        src
        type
        description
      }
      statusReason {
        id
        typeId
        name
        description
        document {
          id
          src
        }
      }
      events {
        id
        status {
          id
          name
        }
        eventDate
        address
        reason {
          id
          name
        }
        documents {
          id
          type
          src
          metadata
        }
        document {
          id
          type
          src
        }
        signatureData
        description
      }
      status {
        id
        name
        color
        label
      }
      user {
        id
        name
      }
      placeId
      place {
        id
        name
        resume
        type
        placeLevelIds
        fieldValues {
          id
          value
          field {
            id
            name
            type
          }
        }
      }
      asset {
        id
        name
      }
      checklist {
        id
        name
      }
      replies {
        id
        value
        notes
        questionId
        insertedAt
        isNonCompliance
        blockIndex
        documents {
          id
          src
          type
          description
        }
        question {
          id
          name
          data
          ordination
          categoryOrdination
          nonComplianceConditions
          private
          documents {
            id
            src
            type
            description
          }
          description
          reference
          parentReference
          type {
            id
            name
          }
          category {
            id
            name
          }
        }
      }
    }
  }
`

const ServiceOrdersLoader = ({ children, id }) => {
  const modalId = useModalData()
  id = id || modalId
  const permalinkToken = usePermalinkToken()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id, permalinkToken: permalinkToken },
    client: serviceOrdersClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state} empty={!data?.serviceOrder}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ServiceOrdersLoader
